export const attachedToEnum = Object.freeze({
  ADHERENT_PRINCIPAL: 'ADHERENT_PRINCIPAL',
  CONJOINT: 'CONJOINT',
  EN_NOM_PROPRE: 'EN_NOM_PROPRE',
  ADHERENT_PRINCIPAL_ET_CONJOINT: 'ADHERENT_PRINCIPAL_ET_CONJOINT',
  AUTRE: 'AUTRE',
  ADHERENT_PRINCIPAL_ET_AUTRE: 'ADHERENT_PRINCIPAL_ET_AUTRE'
});
